export default "__VITE_ASSET__Db7cGMt2__"